import type { MatterExpertRow } from '~/modules/matters/matters.types';
import { UserRole } from '~/shared/types/connect';
import {
  getFirstHiredMatterExpertRow,
  getMatterExpertRowForRetainerRequest,
} from '~/modules/matters/matterExpertUtils';

/**
 * Which expert the request-retainer modal is scoped to.
 * Explicit `retainerModalExpertId` wins; otherwise experts use their invited/hired row,
 * attorneys use the first hired expert on the matter (list order).
 */
export function getEffectiveRetainerExpertId(params: {
  matterExperts: readonly MatterExpertRow[];
  retainerModalExpertId: string | null;
  currentUserRole: UserRole | undefined;
  currentUserId: string | undefined;
}): string | undefined {
  const {
    matterExperts,
    retainerModalExpertId,
    currentUserRole,
    currentUserId,
  } = params;

  if (retainerModalExpertId !== null) {
    return retainerModalExpertId;
  }

  if (currentUserRole === UserRole.EXPERT) {
    if (currentUserId === undefined) {
      return undefined;
    }
    return getMatterExpertRowForRetainerRequest(matterExperts, currentUserId)
      ?.expertId;
  }

  return getFirstHiredMatterExpertRow(matterExperts)?.expertId;
}

/** `MatterExpert.id` for the invited/hired row matching `effectiveRetainerExpertId`, if any. */
export function getRetainerModalMatterExpertId(params: {
  matterExperts: readonly MatterExpertRow[];
  effectiveRetainerExpertId: string | undefined;
}): string | null {
  const { matterExperts, effectiveRetainerExpertId } = params;

  if (effectiveRetainerExpertId === undefined) {
    return null;
  }

  const row = getMatterExpertRowForRetainerRequest(
    matterExperts,
    effectiveRetainerExpertId,
  );

  return row?.id ?? null;
}
